export const PERFORMANCE_SUPPORT_REASONS = [
  'none',
  'exercise_pain',
  'exercise_substitution',
  'video_correction',
  'questions',
  'workout_adjustment',
  'became_pregnant',
] as const;

export type PerformanceSupportReason = (typeof PERFORMANCE_SUPPORT_REASONS)[number];

export const PERFORMANCE_SUPPORT_REASON_LABELS: Record<PerformanceSupportReason, string> = {
  none: 'Nenhum',
  exercise_pain: 'Dor no exercício',
  exercise_substitution: 'Substituição de exercício',
  video_correction: 'Correção de vídeo',
  questions: 'Dúvidas',
  workout_adjustment: 'Ajuste no treino',
  became_pregnant: 'Ficou Grávida',
};

export const PERFORMANCE_SUPPORT_REASON_OPTIONS = PERFORMANCE_SUPPORT_REASONS.map((reason) => ({
  value: reason,
  label: PERFORMANCE_SUPPORT_REASON_LABELS[reason],
}));

export interface PerformanceSupportLatest {
  id: number;
  reason: PerformanceSupportReason;
  createdAt: string;
}

export type PerformanceSupportResponseChoice = 'yes' | 'no' | 'none';

export interface PerformanceSupportHistoryItem {
  id: number;
  reason: PerformanceSupportReason;
  createdAt: string;
  responseChoice: PerformanceSupportResponseChoice | null;
  respondedAt: string | null;
  pregnancyPeriodId: number | null;
  pregnantFrom: string | null;
  pregnantUntil: string | null;
}

export interface PerformanceSupportState {
  latest: PerformanceSupportLatest | null;
  canRegister: boolean;
  nextRegisterOn: string | null;
  history: PerformanceSupportHistoryItem[];
}

export const PERFORMANCE_SUPPORT_RESPONSE_CHOICE_LABELS: Record<
  PerformanceSupportResponseChoice,
  string
> = {
  yes: 'Sim',
  no: 'Não',
  none: 'Nenhum',
};

export function isPerformanceSupportReason(value: string): value is PerformanceSupportReason {
  return (PERFORMANCE_SUPPORT_REASONS as readonly string[]).includes(value);
}

export function performanceSupportReasonLabel(reason: string | null | undefined): string | null {
  if (!reason || !isPerformanceSupportReason(reason) || reason === 'none') {
    return null;
  }

  return PERFORMANCE_SUPPORT_REASON_LABELS[reason];
}
